import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import {process, aggregateBy, CompositeFilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { GridDataResult, PageChangeEvent, SelectionEvent  } from '@progress/kendo-angular-grid';
import { GItem } from '@app/cp/shared/models/GItem';
import * as _ from 'lodash';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { MSCLFilterClass } from '../../shared/classes/filters/MSCLFilterClass';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

interface ColumnSetting {
    field: string;
    title: string;
    format?: string;
    type: 'text' | 'numeric' | 'boolean' | 'date';
    hidden: boolean;

}

@Component({
    selector: 'wip-contract-board',
    templateUrl: './wip-contract-board.component.html',
    styleUrls: ['./wip-contract-board.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConstructionWIPContractBoardComponent extends BaseGridComponent<null, null> implements OnInit, OnDestroy {
    rowSelected(e: SelectionEvent) {

    }
    public aggregates: any[] = [];
    public aggregateResults;
    public gridView: GridDataResult;
    public pageSize = 26;
    customerNameCF: MSCLFilterClass;
    contractAdministratorCF: MSCLFilterClass;
    locationNameCF: MSCLFilterClass;
    pmCF: MSCLFilterClass;
    divisionNameCF: MSCLFilterClass;
    subs_dataRefUpdated: Subscription;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
        this.svc_data = svc_data;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });

        this.aggregates = [
            { field: 'dispatchNumber', aggregate: 'count' },
            { field: 'contractAmount', aggregate: 'sum' },
            { field: 'estimatedCost', aggregate: 'sum' },
            { field: 'totalCostPlusTax', aggregate: 'sum' },
            { field: 'profitDollars', aggregate: 'sum' }
        ];
    }
    subs_dataRef: Subscription;
    svc_data: ConstructionService;
    referenceData: DQOIReferenceData;
    contractAdministratorId: any;

    gridDataPrime: any[] = [];
    //customerId: any;
    //jobClassIds: any;
    //dispatchStatusIds: any;
    constractNo: string;
    billingMonthYear: any;
    projectManagerId: any;

    //Filters
    ProjectManagers: GItem[] = [];
    ContractStatuses: GItem[] = [];
    Customers: GItem[] = [];
    jobClasses: GItem[] = [];

    projectManagerIds: GItem[] = [];
    dispatchStatusIds: GItem[] =[];
    customerIds: GItem[] =[];
    jobClassIds: GItem[] =[];

    filteredData: any[];
    exportFilteredData: any[];

    ColumnHeaders: ColumnSetting[];
    StaticColumnHeaders: ColumnSetting[];
    DynamicColumnHeaders: ColumnSetting[];
    loading: boolean = true;

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    ngOnInit() {
        this.getData();
    }
    getData() {
        this.loading = true;
        console.log('getting data!');
        let param: ConstructionSearchParam = this.getParam();

        this.svc_data.getDynamicConstructionContractInfo(param).subscribe(data => {
            if (data && data.primaryReturn && data.primaryReturn.length > 0) {

                let newAggregates = this.populateDynamicAggregates(data.primaryReturn);
                this.aggregates = this.aggregates.concat(newAggregates);

                this.gridDataPrime = this.processDynamicDataForGrid(data.primaryReturn);
                this.applyFilters();
                this.setColumnHiddenStatus();
            } else {
                this.loading = false;
            }
        });
    }

    processGridData() {
        this.exportFilteredData = filterBy(this.filteredData, this.filter);
        if (CommonFunctions.hasArrayElementValue(this.exportFilteredData)) {
            this.aggregateResults = aggregateBy(this.exportFilteredData, this.aggregates);
            console.log(JSON.stringify(this.aggregateResults));
        }
        { this.aggregateResults = {}; }
        this.customerNameCF = new MSCLFilterClass('customerName', 'customerName', this.filteredData);
        this.contractAdministratorCF = new MSCLFilterClass('contractAdministrator', 'contractAdministrator', this.filteredData);
        this.locationNameCF = new MSCLFilterClass('locationName', 'locationName', this.filteredData);
        this.divisionNameCF = new MSCLFilterClass('divisionName', 'divisionName', this.filteredData);
        this.pmCF = new MSCLFilterClass('pm', 'pm', this.filteredData);
        this.loading = false;
    }

    public pageChange(event: PageChangeEvent): void {
        this.skip = event.skip;
        this.loadProducts();
    }

    private loadProducts(): void {
        //this.gridView = {
        //    data: this.gridData.slice(this.skip, this.skip + this.pageSize),
        //    total: this.gridData.length
        //};
    }

    getParam(initial: boolean = false) : ConstructionSearchParam {
        let param: ConstructionSearchParam = new ConstructionSearchParam();

        if (!initial) {
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.contractAdministratorId = this.contractAdministratorId;
            //param.customerId = this.customerId;
            param.jobClassIds = this.jobClassIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.jobClassIds);
            param.dispatchStatusIds = this.dispatchStatusIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.dispatchStatusIds);
            param.contractNo = this.constractNo;
            param.billingMonthYear = this.billingMonthYear;
        }
        return param;
    }
    apiFilter() {
        this.getData();
    }

    applyFilters() {
        this.loading = true;
        this.filteredData = [];
        if (this.projectManagerIds.length == 0 && this.dispatchStatusIds.length == 0 && this.customerIds.length == 0 && this.jobClassIds.length == 0) {
            this.filteredData = _.cloneDeep(this.gridDataPrime);
        } else {
            let tempFilteredData = _.cloneDeep(this.gridDataPrime);
            if (this.projectManagerIds.length > 0) {
                tempFilteredData.forEach(row => {
                    let filterIndex = this.projectManagerIds.findIndex((element) => { return element === row.pmid });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.dispatchStatusIds.length > 0) {
                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridDataPrime);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.dispatchStatusIds.findIndex((element) => { return element === row.dispatchStatusId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.customerIds.length > 0) {
                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridDataPrime);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.customerIds.findIndex((element) => { return element === row.customerId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }

            if (this.jobClassIds.length > 0) {

                tempFilteredData = _.cloneDeep(this.filteredData.length > 0 ? this.filteredData : this.gridDataPrime);
                this.filteredData = [];
                tempFilteredData.forEach(row => {
                    let filterIndex = this.jobClassIds.findIndex((element) => { return element === row.accountClassId });
                    if (filterIndex != -1 && this.filteredData.findIndex(element => { return element.contractId === row.contractId }) == -1) {
                        this.filteredData.push(row);
                    }
                });
            }
        }
        this.processGridData();
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }

    processDynamicDataForGrid(data: any) {
        let pivoted = this.pivotData(data);
        pivoted = this.PopulateZeros(pivoted);
        this.PopulateFilters(pivoted);

        this.ColumnHeaders = this.getColumnHeaders(pivoted);
        this.StaticColumnHeaders = this.getStaticColumnHeaders(this.ColumnHeaders);
        this.DynamicColumnHeaders = this.getDynamicColumnHeaders(this.ColumnHeaders);

        //let sorted = this.SortDynamicColumns(this.ColumnHeaders);
        //this.ColumnHeaders = sorted;
        //let dateFormated = this.updateDateData(sorted);

        return pivoted;
    }
    public exportGridToExcel(): void {

        this.grid.saveAsExcel();
    }
    pivotData(data) {
        //let test = [];
        var iter = function (pivoted, record) {
            //test.push(pivoted.find((element) => { return element.dispatchId == record.dispatchId }));
            let index = pivoted.findIndex((element) => { return element.contractId === record.contractId });
            if (index > -1 && record.columnTypeTitle && record.columnTypeTitle != '') {
                //pivoted[index][record.columnTypeTitle] = record.columnValue;
                pivoted[index][(record.relatedJobType ? record.relatedJobType.substring(0, 3) + '' : '') + (record.columnType ? record.columnType : '')] = record.columnValue;
            } else if (record.columnTypeTitle && record.columnTypeTitle != '') {
                pivoted.push({
                    contractId: record.contractId,
                    [(record.relatedJobType ? record.relatedJobType.substring(0, 3) + ' ' : '') + (record.columnTypeTitle ? record.columnTypeTitle : '')]: record.columnValue,
                    customerId: record.customerId,
                    customerName: record.customerName,
                    locationName: record.locationName,
                    locationId: record.locationId,
                    dispatchNumber: record.dispatchNumber,
                    dispatchPrimaryId: record.dispatchPrimaryId,
                    receivedDateTime: record.receivedDateTime,
                    estimatedEndDate: record.estimatedEndDate,
                    estimatedBeginDate: record.estimatedBeginDate,
                    contractAmount: record.contractAmount,
                    contractNote: record.contractNote,
                    contractAdminId: record.contractAdminId,
                    contractAdministrator: record.contractAdministrator,
                    dispatchStatusId: record.dispatchStatusId,
                    dispatchStatusName: record.dispatchStatusName,
                    accountClassId: record.accountClassId,
                    accountClassName: record.accountClassName,
                    certPayrollRequired: record.certPayrollRequired,
                    drawDateInfo: record.drawDateInfo,
                    dispatchReason: record.dispatchReason,
                    profitDollars: record.profitDollars,
                    profitPercentage: record.profitPercentage,
                    totalCostPlusTax: record.totalCostPlusTax,
                    mostRecentDrawCost: record.mostRecentDrawCost,
                    divisionName: record.divisionName,
                    co: record.co,
                    pm: record.pm,
                    pmid: record.pmid,
                    dynamicJobWipId: record.dynamicJobWipId,
                    dateExecuted: record.dateExecuted
                });
            } else {
                pivoted.push({
                    contractId: record.contractId,
                    customerId: record.customerId,
                    customerName: record.customerName,
                    locationName: record.locationName,
                    locationId: record.locationId,
                    dispatchNumber: record.dispatchNumber,
                    dispatchPrimaryId: record.dispatchPrimaryId,
                    receivedDateTime: record.receivedDateTime,
                    estimatedEndDate: record.estimatedEndDate,
                    estimatedBeginDate: record.estimatedBeginDate,
                    contractAmount: record.contractAmount,
                    contractNote: record.contractNote,
                    contractAdminId: record.contractAdminId,
                    contractAdministrator: record.contractAdministrator,
                    dispatchStatusId: record.dispatchStatusId,
                    dispatchStatusName: record.dispatchStatusName,
                    accountClassId: record.accountClassId,
                    accountClassName: record.accountClassName,
                    certPayrollRequired: record.certPayrollRequired,
                    drawDateInfo: record.drawDateInfo,
                    dispatchReason: record.dispatchReason,
                    profitDollars: record.profitDollars,
                    profitPercentage: record.profitPercentage,
                    totalCostPlusTax: record.totalCostPlusTax,
                    mostRecentDrawCost: record.mostRecentDrawCost,
                    divisionName: record.divisionName,
                    co: record.co,
                    pm: record.pm,
                    pmid: record.pmid,
                    dynamicJobWipId: record.dynamicJobWipId,
                    dateExecuted: record.dateExecuted
                });
            }

            return pivoted;
        };

        return data.reduce(iter, [])
    }

    populateDynamicAggregates(data) {
        var iter = function (dynAggregates, record) {
            let fieldName = '';
            if (record.columnTypeTitle && record.columnTypeTitle != '') {
                fieldName = (record.relatedJobType ? record.relatedJobType.substring(0, 3) + '' : '') + (record.columnType ? record.columnType : '');
                let index = dynAggregates.findIndex((element) => { return element.field === fieldName });
                if (index > -1) {
                    dynAggregates = dynAggregates;
                } else if (record.columnTypeTitle && record.columnTypeTitle != '') {
                    let newFieldName = (record.relatedJobType ? record.relatedJobType.substring(0, 3) + '' : '') + (record.columnType ? record.columnType : '');
                    dynAggregates.push({
                        field: newFieldName,
                        aggregate: 'sum'
                    }
                        //[(record.relatedJobType ? record.relatedJobType.substring(0, 3) + ' ' : '') + (record.columnTypeTitle ? record.columnTypeTitle : '')]: record.columnValue,
                    );
                }
            }

            return dynAggregates;
        };

        return data.reduce(iter, [])

        //            { field: 'profitDollars', aggregate: 'sum' },

    }

    public PopulateFilters(data: any) {
        data.forEach(item => {
            if (this.ProjectManagers.findIndex((element) => { return element.value === item.pmid }) == -1) {
                this.ProjectManagers.push({ description: item.pm, value: item.pmid, category: null, "reference": null})
            }
            if (this.ContractStatuses.findIndex((element) => { return element.value === item.dispatchStatusId }) == -1) {
                this.ContractStatuses.push({ description: item.dispatchStatusName, value: item.dispatchStatusId, category: null, "reference": null})
            }
            if (this.Customers.findIndex((element) => { return element.value === item.customerId }) == -1) {
                this.Customers.push({ description: item.customerName, value: item.customerId, category: null, "reference": null })
            }
            if (this.jobClasses.findIndex((element) => { return element.value === item.accountClassId }) == -1) {
                this.jobClasses.push({ description: item.accountClassName, value: item.accountClassId, category: null, "reference": null })
            }
        });
    }

    public getColumnHeaders(data) {
        var iter = function (columns, record) {
            let keys = Object.keys(record);
            keys.forEach((key) => {

                if (columns.findIndex((column) => { return column.field === key }) == -1) {

                    let columnSettings: ColumnSetting = {
                        field: key,
                        title: key,
                        format: 'c2',
                        type: 'text',
                        hidden: false
                    };
                    columns.push(columnSettings);
                }
            });

            return columns;
        };

        return data.reduce(iter, [])
    }

    public getStaticColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['contractId', 'customerId', 'customerName', 'locationName', 'locationId', 'dispatchNumber', 'dispatchPrimaryId', 'receivedDateTime', 'estimatedEndDate', 'estimatedBeginDate', 'contractAmount', 'contractNote',
                'contractAdminId', 'dispatchStatusId', 'dispatchStatusName', 'accountClassId', 'accountClassName', 'certPayrollRequired', 'drawDateInfo', 'dispatchReason', 'profitDollars', 'profitPercentage', 'totalCostPlusTax', 'mostRecentDrawCost',
                'divisionName', 'co', 'pm', 'pmid', 'dynamicJobWipId', 'dateExecuted', 'contractAdministrator'];
            if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) != -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, [])
    }

    public getDynamicColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['contractId', 'customerId', 'customerName', 'locationName', 'locationId', 'dispatchNumber', 'dispatchPrimaryId', 'receivedDateTime', 'estimatedEndDate', 'estimatedBeginDate', 'contractNote',
                'contractAdminId', 'dispatchStatusId', 'dispatchStatusName', 'accountClassId', 'accountClassName', 'certPayrollRequired', 'drawDateInfo', 'dispatchReason', 'profitDollars', 'profitPercentage', 'totalCostPlusTax', 'mostRecentDrawCost',
                'divisionName', 'co', 'pm', 'pmid', 'dynamicJobWipId', 'dateExecuted', 'contractAdministrator'];
            if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) == -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, [])
    }

    SortDynamicColumns(data) {
        let sorted = data;
        return sorted;
    }

    PopulateZeros(data) {
        //data.forEach((row) => {
        //    let staticColumns: any = ['contractId', 'customerId', 'customerName', 'locationName', 'locationId', 'dispatchNumber', 'receivedDateTime', 'estimatedEndDate', 'estimatedBeginDate', 'contractNote',
        //        'contractAdminId', 'dispatchStatusId', 'accountClassId', 'certPayrollRequired', 'drawDateInfo', 'dispatchReason', 'profitDollars', 'profitPercent', 'totalCostPlusTax', 'mostRecentDrawCost',
        //        'divisionName', 'co', 'pm', 'pmid', 'dynamicJobWipId', 'dateExecuted', 'contractAdministrator'];
        //    if () {

        //    }
        //});
        return data;
    }

    public updateDateData(data) {
        var iter = function (columns, record) {
            let keys = Object.keys(record);
            keys.forEach((key) => {

                if (columns.findIndex((column) => { return column.field === key }) == -1) {

                    //let columnSettings: ColumnSetting = {
                    //    field: key,
                    //    title: key,
                    //    format: 'c2',
                    //    type: 'text',
                    //    hidden: false
                    //};
                    //columns.push(columnSettings);

                    //datePipe.transform(Date.now(), 'yyyy-MM-dd');

                }
            });

            return columns;
        };

        return data.reduce(iter, [])
    }

    public getColumnHiddenStatus(column: string) {
        let hidden: boolean = false;
        switch (column) {
            case ("contractId"):
            case ("customerId"):
            case ("locationId"):
            case ("contractAdminId"):
            case ("dispatchStatusId"):
            case ("accountClassId"):
            case ("pmid"):
            case ("dynamicJobWipId"):
            case ("dateExecuted"):
                hidden = true;
                break;
            default:
                hidden = false;
        }
        return hidden;
    }

    public setColumnHiddenStatus() {
        this.ColumnHeaders.forEach((column) => {
            switch (column.title) {
                case ("contractId" || "customerId" || "locationId" || "contractAdminId" || "dispatchStatusId" || "accountClassId" || "pmid" || "dynamicJobWipId" || "dateExecuted"):
                    column.hidden = true;
                    break;
                default:
                    column.hidden = false;
            }
        });
        console.log("Are we hidden? " + JSON.stringify(this.ColumnHeaders));
    }

    public getColumnFormatStyle(column: string) {
        let format: any;
        switch (column) {
            case ("contractId"):
            case ("customerId"):
            case ("locationId"):
            case ("contractAdminId"):
            case ("dispatchStatusId"):
            case ("accountClassId"):
            case ("pmid"):
            case ("dynamicJobWipId"):
            case ("dateExecuted"):
                format = '';
                break;
            case ("locationName"):
            case ("dispatchNumber"):
            case ("dispatchPrimaryId"):
            case ("contractNote"):
            case ("certPayrollRequired"):
            case ("dispatchReason"):
            case ("divisionName"):
            case ("co"):
            case ("pm"):
                format = '';
                break;
            case ("receivedDateTime"):
            case ("estimatedEndDate"):
            case ("estimatedBeginDate"):
            case ("drawDateInfo"):
                format = { date: 'short' };
                break;
            case ("Labor"):
            case ("profitDollars"):
            case ("totalCostPlusTax"):
            case ("mostRecentDrawCost"):
                format = 'c2';
                break;
            case ("profitPercent"):
                format = 'p2';
                break;
            default:
                format = 'c2';
        }

        return format;
    }

    rowClassFunction(context: RowClassArgs) {
        let data: any = context.dataItem;
        let rowClass = {};
        if (data.dispatchStatusId == "57e24f4b-a4f4-41ee-969f-a441554feaf4") {
        }
        switch (data.dispatchStatusId.toString()) {
            case "57e24f4b-a4f4-41ee-969f-a441554feaf4": //In Progress
                rowClass = { inprogress: true };
                break;
            case "9168c82b-a790-4423-90fe-8514cc653bf3": //Off Site
                rowClass = { offsite: true };
                break;
            case "d69f143d-36e8-47f3-a596-c570bbd02cf0": //Billed
                rowClass = { billed: true };
                break;
            case "76a083bc-0061-4473-a6f0-ce5081f4f8da": //Closed
                rowClass = { closed: true };
                break;
            default:
            // code block
        }
        return rowClass;
    }

    testColumns: any = ["contractId", "Labor", "customerId", "locationName", "locationId", "dispatchNumber", "dispatchPrimaryId",
        "receivedDateTime", "estimatedEndDate", "estimatedBeginDate", "contractNote", "contractAdminId", "dispatchStatusId",
        "accountClassId", "certPayrollRequired", "drawDateInfo", "dispatchReason", "profitDollars", "profitPercent", "totalCostPlusTax",
        "mostRecentDrawCost", "divisionName", "co", "pm", "pmid", "dynamicJobWipId", "dateExecuted", "Material", "Other", "Warranty",
        "OrderCost", "BilledEquip", "BilledNoEquip", "ChangeOrders", "BidEquipCost", "BidEquipSale", "VendorCredit", "VendCredOther", "MfgWarranty", "CreditCards"];

    DefaultColumnOrder: any = [
        { header: 'pm', order: 0 },
        { header: 'contractAdminId', order: 1 },
        { header: 'customerId', order: 2 },
        { header: 'locationName', order: 3 },
        { header: 'dispatchReason', order: 4 },
        { header: 'dispatchNumber', order: 5 },
        { header: 'estimatedBeginDate', order: 6 },
        { header: 'estimatedEndDate', order: 7 },
        { header: 'pm', order: 8 },
        { header: 'pm', order: 9 },
        { header: 'pm', order: 10 },
        { header: 'pm', order: 11 }
    ];

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.processGridData();
    }
    public filter: CompositeFilterDescriptor;
    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.exportFilteredData) this.exportFilteredData = [];
        const result: ExcelExportData = {
            data: process(this.exportFilteredData as any, {}).data,
        };
        return result;
    }
}
